import Badge from "@/components/ui/Badge";
import type { SatelliteEvent } from "@/interfaces/satellite_event";

const LABELS: Record<SatelliteEvent["aasm_state"], string> = {
  draft: "Draft",
  submitted: "Under review",
  approved: "Approved",
  rejected: "Needs changes",
  not_selected: "Not selected",
};

const TONES = {
  draft: "neutral",
  submitted: "info",
  approved: "success",
  rejected: "warning",
  not_selected: "neutral",
} as const;

export default function EventStatusBadge({
  state,
}: {
  state: SatelliteEvent["aasm_state"];
}) {
  return <Badge tone={TONES[state]}>{LABELS[state]}</Badge>;
}
